var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"d-flex align-items-center justify-content-center",attrs:{"id":"modal"}},[_vm._t("modal")],2)}
var staticRenderFns = []

export { render, staticRenderFns }